module.exports = __webpack_public_path__ + "static/media/11-seo.f98e8064.png";